import { useContext } from "react";
import { LocalStorageContext } from "../providers/local-storage-provider";


export const useLocalStorageSync = () => {
    return useContext(LocalStorageContext);
};